import { Dispatch } from "react";
import { ErrorResponse } from "../interfaces/ErrorResponse";

export const fieldHasErrors = (fieldName: string, errors: ErrorResponse | null) => {
  if (errors && errors.data && Array.isArray(errors.data)) {
    const errorMessage = errors.data.find(i => i.field === fieldName);
    if (errorMessage && errorMessage.message) return true;
  }
  return false;
}

export const fieldErrorMessage = (fieldName: string, errors: ErrorResponse | null) => {
  if (errors && errors.data && Array.isArray(errors.data)) {
    const errorMessage = errors.data.find(i => i.field === fieldName);
    if (errorMessage && errorMessage.message) return errorMessage.message;
  }
  return "";
}

export const clearError = (fieldName: string, errors: ErrorResponse | null, setError: any, dispatch: Dispatch<any>) => {
  if (errors) {
    dispatch(setError({
      ...errors,
      data: {
        ...errors.data,
        [`${fieldName}`]: []
      }
    }));
  }
}